import { Component, EventEmitter, Input, OnInit, ViewChild, signal } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  LeaProfessionalDevelopmentClient,
  SimpleSelectOptionDto,
  VerifyRemainingProfessionalDevelopmentHoursCommand,
} from 'src/shared/services/api.service';
import { catchValidationErrors } from 'src/shared/utilities/validator-utilities';
import { finalize, Observable, take } from 'rxjs';

@Component({
  selector: 'cert-verify-remaining-pd-modal',
  standalone: false,
  templateUrl: './verify-remaining-pd-modal.component.html',
})
export class VerifyRemainingProfessionalDevelopmentModalComponent implements OnInit {
  @Input() personId$!: Observable<number>;
  @Input() leaCodeId!: number;
  @Input() professionalDevelopmentTypeOptions: SimpleSelectOptionDto[] = [];
  @ViewChild('awardForm') form!: NgForm;
  submitting = signal(false);
  verifyRemainingProfessionalDevelopmentHoursCommand!: VerifyRemainingProfessionalDevelopmentHoursCommand;

  errorEmitter = new EventEmitter<any>();

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly professionalDevelopmentClient: LeaProfessionalDevelopmentClient,
  ) {}

  ngOnInit() {
    this.personId$.pipe(take(1)).subscribe((personId) => {
      this.verifyRemainingProfessionalDevelopmentHoursCommand = {
        personId: personId,
        description: undefined,
        completionDate: undefined,
        professionalDevelopmentTypeCodeId:
          this.professionalDevelopmentTypeOptions.length === 1
            ? this.professionalDevelopmentTypeOptions[0].id
            : undefined,
        leaCodeId: this.leaCodeId,
      };
      (this.verifyRemainingProfessionalDevelopmentHoursCommand as any).leaCodeId = this.leaCodeId;
    });
  }

  confirm() {
    this.submitting.set(true);
    this.professionalDevelopmentClient
      .verifyRemainingProfessionalDevelopmentHours(this.verifyRemainingProfessionalDevelopmentHoursCommand)
      .pipe(
        catchValidationErrors(this.form, this.errorEmitter),
        finalize(() => this.submitting.set(false)),
      )
      .subscribe({
        next: () => this.activeModal.close(true),
      });
  }

  dismiss() {
    this.activeModal.dismiss();
  }
}
